/** Size sort order — garment sizes ascending, then numeric (kids) */
const SIZE_ORDER: Record<string, number> = {
  'XXS': 1, '2XS': 1,
  'XS': 2,
  'S': 3,
  'M': 4,
  'L': 5,
  'XL': 6,
  'XXL': 7, '2XL': 7, '2X': 7,
  '3XL': 8, '3X': 8,
  '4XL': 9, '4X': 9,
  '5XL': 10, '5X': 10,
};

export function sizeRank(size: string | null | undefined): number {
  if (!size) return 999;
  const upper = size.trim().toUpperCase();
  if (SIZE_ORDER[upper] !== undefined) return SIZE_ORDER[upper];
  // Numeric sizes (kids: 2, 4, 6, ... 16)
  const num = parseInt(upper, 10);
  if (!isNaN(num)) return 100 + num;
  return 998;
}

/** Sort variants by color (alphabetical), then size (garment order: XS → 4XL, kids: 2 → 16) */
export function sortVariants<T extends { color: string | null; size: string | null }>(variants: T[]): T[] {
  return [...variants].sort((a, b) => {
    const colorA = (a.color ?? '').toLowerCase();
    const colorB = (b.color ?? '').toLowerCase();
    if (colorA !== colorB) return colorA.localeCompare(colorB);
    return sizeRank(a.size) - sizeRank(b.size);
  });
}
